import { prop } from './index';
import API from '../services/API';

interface ArticleContentDetails {
  body: string;
  annotation: string;
  name: string;
  anotation?: string;
}

const ARTICLE_TEASER_FIELDS = [
  'id',
  'name',
  'url',
  'image',
  'created_date',
  'last_update',
  'sf_form',
  'is_top',
  'ordering',
  'lang_id',
  'sitemapIds',
  'sitemapNames',
];

export const getArticleTeaser = article => {
  if (!article || typeof article !== 'object') {
    return article;
  }

  const teaser: any = {};
  ARTICLE_TEASER_FIELDS.forEach(field => {
    if (article[field] !== undefined) {
      teaser[field] = article[field];
    }
  });
  teaser.json_content = {
    anotation: prop(article, 'json_content.anotation', ''),
  };

  return teaser;
};

export const getArticleTeasers = articles => {
  const list = prop(articles, 'articles', null);

  if (!Array.isArray(list)) {
    return articles;
  }

  return { ...articles, articles: list.map(getArticleTeaser) };
};

export const resolveArticleContentDetails = (
  article,
): ArticleContentDetails => {
  const name = prop(article, 'json_content.name', '');
  let body = prop(article, 'json_content.body', {});
  let annotation = prop(article, 'json_content.annotation', {});
  if (
    body &&
    Object.entries(body).length === 0 &&
    body.constructor === Object
  ) {
    body = '';
  }

  if (
    Object.entries(annotation).length === 0 &&
    annotation.constructor === Object
  ) {
    annotation = '';
  }
  return {
    name,
    body,
    annotation,
  };
};

export const getRssFeedUrl = (sitemapId = 0, lang) => {
  const basicUrl = `${process.env.REACT_APP_API_BASE_URL}/rss`;

  return sitemapId !== 0
    ? `${basicUrl}?sitemap_id=${sitemapId}&lang_id=${lang}`
    : `${basicUrl}?lang_id=${lang}`;
};

export const getArticleProducts = article => {
  return prop(article, 'products', []);
};

export const replaceMatchesInBody = (
  body: string,
  regex: RegExp,
  newTag: string,
  matchValuesArray: Array<{ matchValueId: string; newValueId: string }>,
) => {
  if (!body) {
    return '';
  }

  const matches = body && body.match(regex);
  if (!matches) {
    return body;
  }

  let newBody = body;
  matches.map(stringMatch => {
    let values = '';
    matchValuesArray.map(m => {
      const srcSplit = stringMatch.split(`${m.matchValueId}="`);
      let id = '';
      if (srcSplit && srcSplit.length > 1) {
        id = srcSplit[1].split('"')[0];
      }
      if (id !== '') {
        values += ` ${m.newValueId}="${id}" `;
      }
    });
    newBody = newBody.replace(stringMatch, `<${newTag}${values}></${newTag}>`);
  });

  return newBody;
};
